export function sortCodeParser(code: string | number): string | undefined {
  code = '' + code;
  const isOkay = /^\d{2}-?\d{2}-?\d{2}$/.test(code);
  return isOkay ? code.replace(/-/g, '') : undefined;
}

export function isSortCode(code: string | number): boolean {
  return sortCodeParser(code) !== undefined;
}
